import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import TechnicalExpertiseSection from "@/components/TechnicalExpertiseSection";
import ServicesSection from "@/components/ServicesSection";
import TrustSignalsSection from "@/components/TrustSignalsSection";
import CoursesSection from "@/components/CoursesSection";
import ContactSection from "@/components/ContactSection";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />
      <main>
        <HeroSection />
        <TechnicalExpertiseSection />
        <ServicesSection />
        <TrustSignalsSection />
        <CoursesSection />
        <ContactSection />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
